import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { get, map, constant, times, isEmpty } from 'lodash';

import { getCurrentRoutes as rts } from '../../../utils/language';
import LoadingMiniListing from '../../../components/MiniListing/LoadingMiniListing';
import ConditionalImage from '../../../components/ConditionalImage';

import './styles.css';

const RelatedArticles = (props) => {
  const {
    isLoading,
    articles
  } = props;
  const { RESOURCES_URL_ROOT } = rts();

  const renderRelatedArticles = (relatedArticles) => relatedArticles && relatedArticles.length > 0 ?
    (
      <div className="related-articles">
        {relatedArticles.map(
          (article, index) => {
            const name = get(article, 'name');
            const title = get(article, 'title');
            const excerpt = get(article, 'excerpt');
            const categories = get(article, 'categories');
            const category = get(categories, '[0]', '');
            const imageUrl = get(article, 'imageUrl');

            return (
              <article key={index}>
                <a href={`${RESOURCES_URL_ROOT}${name}`}>
                  <div className="image-container">
                    {
                      !isEmpty(imageUrl) &&
                      <ConditionalImage src={imageUrl} alt={title} />
                    }
                  </div>
                  <div className="content-container">
                    <div className="categories-wrapper">
                      <p className="categories">{category}</p>
                    </div>
                    <div className="title-wrapper">
                      <p className="title">{title}</p>
                    </div>
                    <div className="excerpt-wrapper">
                      <p className="excerpt">{excerpt}</p>
                    </div>
                  </div>
                </a>
              </article>
            );
          }
        )}
      </div>
    ) :
    null;

  const renderLoading = () => {
    let list = times(4, constant(null));
    return map(list, (listing, index) => {
      return <LoadingMiniListing key={index} />;
    });
  };

  return (
    isLoading ? renderLoading() : renderRelatedArticles(articles)
  );
};

RelatedArticles.defaultProps = {
  isLoading: false,
  articles: []
};

RelatedArticles.propTypes = {
  isLoading: PropTypes.bool,
  articles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      excerpt: PropTypes.string,
      name: PropTypes.string,
      categories: PropTypes.arrayOf(PropTypes.string),
      imageUrl: PropTypes.string,
    })
  )
};

export default injectIntl(RelatedArticles);
